import React from "react";

const Banner: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="120"
      height="48"
      viewBox="0 0 120 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.668 17.375C11.4437 16.9453 11.2421 16.502 11.0657 16.0461C4.37407 20.2078 -0.0730147 27.6942 0.000907771 36.1564H1.39871C1.34444 28.2686 5.46001 21.2964 11.668 17.375Z"
        fill="#F36221"
      />
      <path
        d="M14.1369 20.7066C13.7555 20.3315 13.396 19.9336 13.0625 19.5156C7.56538 22.9842 3.92557 29.1771 3.99613 36.1564H5.59973C5.51185 29.6473 8.9564 23.8669 14.1369 20.7066Z"
        fill="#F36221"
      />
      <path
        d="M17.6985 23.2029C17.1911 22.9606 16.7014 22.6864 16.2318 22.3828C11.3227 24.9843 7.98865 30.2141 8.06677 36.1563H9.42089C9.35995 30.4109 12.7778 25.4142 17.6985 23.2029Z"
        fill="#F36221"
      />
      <path
        d="M35.7834 16.0461C35.6061 16.5087 35.4029 16.9596 35.1777 17.3952C40.0322 20.4778 43.599 25.4107 44.8876 31.2041H46.2501C44.9472 24.8169 41.0789 19.3802 35.7834 16.0461Z"
        fill="#F36221"
      />
      <path
        d="M33.8076 19.5156C33.4691 19.9437 33.1054 20.3508 32.7173 20.7327C36.5167 23.07 39.3728 26.796 40.5816 31.2041H42.1944C40.9747 26.304 37.9179 22.1432 33.8076 19.5156Z"
        fill="#F36221"
      />
      <path
        d="M30.6726 22.3828C30.2055 22.6881 29.7166 22.964 29.2109 23.2079C32.6382 24.7563 35.3339 27.6438 36.6309 31.2041H38.0068C36.7795 27.3923 34.12 24.2349 30.6726 22.3828Z"
        fill="#F36221"
      />
      <path
        d="M23.42 0C12.7492 0.103451 8.1173 13.353 16.347 20.1018C20.359 23.4165 26.4819 23.4156 30.4947 20.1018C38.7235 13.3538 34.0908 0.101767 23.42 0ZM23.4066 21.1313C17.9783 21.1313 13.5783 16.7257 13.5783 11.2906C14.0956 -1.76281 32.7194 -1.75909 33.2348 11.2907C33.2348 16.7257 28.8348 21.1313 23.4066 21.1313Z"
        fill="#F36221"
      />
      <path
        d="M23.42 24.6724C9.55795 25.0426 8.0617 44.6196 21.6341 47.13V45.5311C17.0518 44.6959 13.5783 40.6789 13.5783 35.8503C13.6927 25.5717 27.242 22.3171 32.0722 31.2042H33.654C31.8589 27.3462 27.9511 24.6724 23.42 24.6724Z"
        fill="#F36221"
      />
      <path
        d="M17.0637 36.1571C17.0637 32.3467 19.9597 29.54 23.8767 29.54C25.7702 29.54 27.4781 30.172 28.629 31.436L27.7565 32.3096C24.3939 28.9631 18.3162 31.3363 18.4189 36.1572C18.3205 40.9811 24.4034 43.3663 27.7565 39.9861L28.629 40.8597C27.4781 42.1236 25.7702 42.7742 23.8581 42.7742C19.9597 42.7742 17.0637 39.9675 17.0637 36.1571Z"
        fill="#2E2E2E"
      />
      <path
        d="M38.0411 36.6033V42.6627H36.7787V41.1386C35.3507 43.6857 29.751 43.2182 29.8544 39.9118C29.9238 36.5483 33.865 37.1988 36.723 37.1423V36.5475C36.8471 33.2384 32.4744 33.503 30.7083 35.1163L30.1143 34.1312C31.0982 33.2947 32.5462 32.8115 34.087 32.8115C36.6117 32.8115 38.0411 34.0754 38.0411 36.6033ZM36.723 39.726V38.1275H33.66C31.7665 38.1275 31.1539 38.8709 31.1539 39.8746C31.1539 41.0085 32.0635 41.7148 33.6229 41.7148C35.108 41.7148 36.2033 41.0085 36.723 39.726Z"
        fill="#2E2E2E"
      />
      <path
        d="M46.0796 32.8115V34.094C43.9265 33.915 42.457 35.2512 42.4782 37.6813L42.4782 42.6627H41.1602V32.8859H42.4225V34.8003C43.0351 33.4993 44.2789 32.8115 46.0796 32.8115Z"
        fill="#2E2E2E"
      />
      <path
        d="M56.4015 38.1831H48.2333C48.3736 41.5797 52.9332 42.727 55.0649 40.302L55.8074 41.1571C54.9349 42.198 53.5797 42.7555 52.0389 42.7555C48.9945 42.7555 46.9153 40.6738 46.9153 37.7742C46.9853 30.9304 56.8955 31.2879 56.4015 38.1831ZM48.2333 37.198H55.1577C54.8075 32.8777 48.5872 32.8618 48.2333 37.198Z"
        fill="#2E2E2E"
      />
      <path
        d="M58.9263 29.6516H60.3V42.6627H58.9263V29.6516Z"
        fill="#2E2E2E"
      />
      <path
        d="M72.7748 36.9936V42.6627H71.4567V37.1238C71.4567 35.0606 70.38 34.0011 68.5236 34.0011C66.4259 34.0011 65.1078 35.3022 65.1078 37.5327V42.6627H63.7898V32.8859H65.0522V34.6888C65.7576 33.4993 67.0756 32.8115 68.765 32.8115C71.1411 32.8115 72.7748 34.187 72.7748 36.9936Z"
        fill="#2E2E2E"
      />
      <path
        d="M84.8416 28.8711V42.6628H83.5792V40.7297C82.781 42.0494 81.4258 42.7557 79.8107 42.7557C77.0262 42.7557 74.947 40.7297 74.947 37.7744C74.947 34.819 77.0262 32.8116 79.8107 32.8116C81.3701 32.8116 82.7067 33.4807 83.5235 34.7447V28.8711H84.8416ZM83.5421 37.7744C83.5421 35.4881 81.9827 33.964 79.9221 33.964C75.0788 33.9465 75.0798 41.6029 79.9222 41.5848C81.9827 41.5848 83.5421 40.0606 83.5421 37.7744Z"
        fill="#2E2E2E"
      />
      <path
        d="M96.5554 38.1831H88.3874C88.5276 41.5797 93.0873 42.727 95.2189 40.302L95.9614 41.1571C95.0889 42.198 93.7337 42.7555 92.193 42.7555C89.1485 42.7555 87.0693 40.6738 87.0693 37.7742C87.1393 30.9303 97.0497 31.2879 96.5554 38.1831ZM88.3874 37.198H95.3117C94.9616 32.8776 88.7411 32.8618 88.3874 37.198Z"
        fill="#2E2E2E"
      />
      <path
        d="M107.304 38.1831H99.1361C99.2764 41.5797 103.836 42.727 105.968 40.302L106.71 41.1571C105.838 42.198 104.483 42.7555 102.942 42.7555C99.8973 42.7555 97.8181 40.6738 97.8181 37.7742C97.888 30.9303 107.799 31.2879 107.304 38.1831ZM99.1361 37.198H106.06C105.71 32.8776 99.4899 32.8618 99.1361 37.198Z"
        fill="#2E2E2E"
      />
      <path
        d="M118.461 28.8711V42.6628H117.199V40.7297C116.401 42.0494 115.045 42.7557 113.43 42.7557C110.646 42.7557 108.567 40.7297 108.567 37.7744C108.567 34.819 110.646 32.8116 113.43 32.8116C114.99 32.8116 116.326 33.4807 117.143 34.7447V28.8711H118.461ZM117.162 37.7744C117.162 35.4881 115.602 33.964 113.542 33.964C108.698 33.9465 108.699 41.6029 113.542 41.5848C115.602 41.5848 117.162 40.0606 117.162 37.7744Z"
        fill="#2E2E2E"
      />
      <path
        d="M61.6511 44.7602H60.4114V44.4373H63.2639V44.7602H62.0242V47.9696H61.6511V44.7602Z"
        fill="#2E2E2E"
      />
      <path
        d="M66.1266 46.4306V47.9697H65.7688V46.4659C65.7688 45.9058 65.4765 45.6181 64.9725 45.6181C64.4029 45.6181 64.0451 45.9714 64.0451 46.5769V47.9697H63.6873V44.2253H64.0451V45.7796C64.2416 45.4718 64.5895 45.2952 65.038 45.2952C65.6831 45.2952 66.1266 45.6686 66.1266 46.4306Z"
        fill="#2E2E2E"
      />
      <path
        d="M69.3223 46.7535H67.1047C67.1427 47.6756 68.3807 47.9872 68.9594 47.3287L69.161 47.5609C68.9241 47.8435 68.5562 47.9948 68.1379 47.9948C67.3113 47.9948 66.7468 47.4297 66.7468 46.6425C66.7659 44.7844 69.4563 44.8814 69.3223 46.7535ZM67.1047 46.486H68.9845C68.8895 45.3131 67.2007 45.3089 67.1047 46.486Z"
        fill="#2E2E2E"
      />
      <path
        d="M74.2108 44.4373V47.9696H73.8429V46.3397H71.6354V47.9696H71.2625V44.4373H71.6354V46.0117H73.8429V44.4373H74.2108Z"
        fill="#2E2E2E"
      />
      <path
        d="M77.4971 46.7535H75.2795C75.3176 47.6756 76.5555 47.9872 77.1342 47.3287L77.3358 47.5609C77.0989 47.8435 76.731 47.9948 76.3127 47.9948C75.4861 47.9948 74.9216 47.4297 74.9216 46.6425C74.9407 44.7844 77.6311 44.8814 77.4971 46.7535ZM75.2795 46.486H77.1593C77.0643 45.3131 75.3755 45.3089 75.2795 46.486Z"
        fill="#2E2E2E"
      />
      <path
        d="M80.0627 46.3246V47.9697H79.72V47.5559C79.3356 48.2476 77.8085 48.1183 77.8401 47.2228C77.8589 46.3097 78.9289 46.4863 79.7049 46.471V46.3095C79.7385 45.411 78.5514 45.4829 78.0719 45.9209L77.9106 45.6534C78.1777 45.4263 78.5708 45.2952 78.9892 45.2952C79.6746 45.2952 80.0627 45.6383 80.0627 46.3246ZM79.7049 47.1724V46.7384H78.8733C78.3592 46.7384 78.1929 46.9403 78.1929 47.2127C78.1929 47.5206 78.4398 47.7124 78.8632 47.7124C79.2664 47.7124 79.5638 47.5206 79.7049 47.1724Z"
        fill="#2E2E2E"
      />
      <path
        d="M82.275 45.2952V45.6433C81.6905 45.5948 81.2915 45.9575 81.2973 46.6173L81.2973 47.9697H80.9395V45.3154H81.2822V45.8351C81.4485 45.4819 81.7862 45.2952 82.275 45.2952Z"
        fill="#2E2E2E"
      />
      <path
        d="M84.3367 47.8083C84.1956 47.9344 83.9839 47.9949 83.7773 47.9949C83.2784 47.9949 83.0012 47.7124 83.0012 47.2229V45.6182H82.5273V45.3154H83.0012V44.7351H83.359V45.3154H84.1654V45.6182H83.359V47.2027C83.359 47.5156 83.5203 47.6871 83.8176 47.6871C83.9638 47.6871 84.1099 47.6418 84.2108 47.5509L84.3367 47.8083Z"
        fill="#2E2E2E"
      />
      <path
        d="M85.8486 46.6425C85.8486 45.8553 86.4232 45.2952 87.1993 45.2952C88.991 45.2991 88.9862 47.9892 87.1993 47.9949C86.4232 47.9949 85.8486 47.4297 85.8486 46.6425ZM88.1822 46.6425C88.1822 46.0218 87.7638 45.608 87.1993 45.608C85.8845 45.6033 85.8848 47.682 87.1993 47.677C87.7638 47.677 88.1822 47.2632 88.1822 46.6425Z"
        fill="#2E2E2E"
      />
      <path
        d="M89.5882 45.0026V45.3154H90.4046V45.6182H89.5983V47.9698H89.2404V45.6182H88.7666V45.3154H89.2404V44.9874C89.2404 44.5131 89.5226 44.2002 90.0417 44.2002C90.2383 44.2002 90.4399 44.2557 90.5709 44.3668L90.45 44.6342C90.3492 44.5484 90.2081 44.503 90.0568 44.503C89.7494 44.503 89.5882 44.6745 89.5882 45.0026Z"
        fill="#2E2E2E"
      />
      <path
        d="M95.0416 44.4373V47.9696H94.6737V46.3397H92.4662V47.9696H92.0933V44.4373H92.4662V46.0117H94.6737V44.4373H95.0416Z"
        fill="#2E2E2E"
      />
      <path
        d="M95.7524 46.6425C95.7524 45.8553 96.327 45.2952 97.1031 45.2952C98.8948 45.2991 98.89 47.9892 97.1031 47.9949C96.327 47.9949 95.7524 47.4297 95.7524 46.6425ZM98.086 46.6425C98.086 46.0218 97.6676 45.608 97.1031 45.608C95.7883 45.6033 95.7886 47.682 97.1031 47.677C97.6676 47.677 98.086 47.2632 98.086 46.6425Z"
        fill="#2E2E2E"
      />
      <path
        d="M103.458 46.4306V47.9697H103.101V46.4659C103.101 45.9057 102.818 45.6181 102.34 45.6181C101.795 45.6181 101.453 45.9714 101.453 46.5769V47.9697H101.095V46.4659C101.095 45.9057 100.812 45.6181 100.329 45.6181C99.7894 45.6181 99.4416 45.9714 99.4416 46.5769V47.9697H99.0837V45.3154H99.4265V45.7998C99.7786 45.1375 101.045 45.0959 101.342 45.8553C101.533 45.5122 101.911 45.2951 102.39 45.2951C103.035 45.2951 103.458 45.6686 103.458 46.4306Z"
        fill="#2E2E2E"
      />
      <path
        d="M106.654 46.7535H104.436C104.475 47.6756 105.713 47.9872 106.291 47.3287L106.493 47.5609C106.256 47.8435 105.888 47.9948 105.47 47.9948C104.643 47.9948 104.079 47.4297 104.079 46.6425C104.098 44.7844 106.788 44.8814 106.654 46.7535ZM104.436 46.486H106.316C106.221 45.3131 104.533 45.3089 104.436 46.486Z"
        fill="#2E2E2E"
      />
      <path
        d="M108.282 46.2035C108.282 45.169 109.068 44.407 110.131 44.407C110.645 44.407 111.109 44.5786 111.422 44.9217L111.185 45.1589C110.272 44.2504 108.622 44.8946 108.65 46.2035C108.62 47.5109 110.277 48.1614 111.185 47.243L111.422 47.4802C111.109 47.8233 110.645 48 110.126 48C109.068 48 108.282 47.238 108.282 46.2035Z"
        fill="#2E2E2E"
      />
      <path
        d="M114.007 46.3246V47.9697H113.665V47.5559C113.28 48.2476 111.753 48.1183 111.785 47.2228C111.804 46.3097 112.874 46.4863 113.649 46.471V46.3095C113.683 45.411 112.496 45.4829 112.016 45.9209L111.855 45.6534C112.122 45.4263 112.515 45.2952 112.934 45.2952C113.619 45.2952 114.007 45.6383 114.007 46.3246ZM113.649 47.1724V46.7384H112.818C112.304 46.7384 112.137 46.9403 112.137 47.2127C112.137 47.5206 112.384 47.7124 112.808 47.7124C113.211 47.7124 113.508 47.5206 113.649 47.1724Z"
        fill="#2E2E2E"
      />
      <path
        d="M116.22 45.2952V45.6433C115.636 45.5948 115.237 45.9575 115.242 46.6173L115.242 47.9697H114.885V45.3154H115.227V45.8351C115.394 45.4819 115.731 45.2952 116.22 45.2952Z"
        fill="#2E2E2E"
      />
      <path
        d="M119.053 46.7535H116.835C116.873 47.6756 118.111 47.9872 118.69 47.3287L118.891 47.5609C118.655 47.8435 118.287 47.9948 117.868 47.9948C117.042 47.9948 116.477 47.4297 116.477 46.6425C116.496 44.7844 119.187 44.8814 119.053 46.7535ZM116.835 46.486H118.715C118.62 45.3131 116.931 45.3089 116.835 46.486Z"
        fill="#2E2E2E"
      />
      <path
        d="M119.461 47.7173C119.467 47.355 119.992 47.3595 120.001 47.7173C119.991 48.0813 119.469 48.0857 119.461 47.7173Z"
        fill="#2E2E2E"
      />
    </svg>
  );
};

export default Banner;
